import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { CornerControls } from './CornerControls/ClassicCornerControls';
import { RowControls } from './RowControls/ClassicControls';
export var FloatingControlsWithSelection = function FloatingControlsWithSelection(_ref) {
  var editorView = _ref.editorView,
    tableRef = _ref.tableRef,
    isInDanger = _ref.isInDanger,
    isResizing = _ref.isResizing,
    isHeaderRowEnabled = _ref.isHeaderRowEnabled,
    isHeaderColumnEnabled = _ref.isHeaderColumnEnabled,
    hoveredRows = _ref.hoveredRows,
    stickyTop = _ref.stickyTop,
    hoverRows = _ref.hoverRows,
    selectRow = _ref.selectRow,
    tableActive = _ref.tableActive,
    api = _ref.api;
  // selection
  var _useSharedPluginState = useSharedPluginState(api, ['selection'], {
      disabled: editorExperiment('platform_editor_usesharedpluginstateselector', true)
    }),
    selectionState = _useSharedPluginState.selectionState;
  var selectionsSelector = useSharedPluginStateSelector(api, 'selection.selection', {
    disabled: editorExperiment('platform_editor_usesharedpluginstateselector', false)
  });
  var selection = editorExperiment('platform_editor_usesharedpluginstateselector', true) ? selectionsSelector : selectionState === null || selectionState === void 0 ? void 0 : selectionState.selection;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CornerControls, {
    editorView: editorView,
    tableRef: tableRef,
    isInDanger: isInDanger,
    isResizing: isResizing,
    isHeaderRowEnabled: isHeaderRowEnabled,
    isHeaderColumnEnabled: isHeaderColumnEnabled,
    hoveredRows: hoveredRows,
    stickyTop: tableActive ? stickyTop : undefined
  }), /*#__PURE__*/React.createElement(RowControls, {
    selection: selection,
    editorView: editorView,
    tableRef: tableRef,
    hoverRows: hoverRows,
    hoveredRows: hoveredRows,
    isInDanger: isInDanger,
    isResizing: isResizing,
    selectRow: selectRow,
    stickyTop: tableActive ? stickyTop : undefined
  }));
};